// https://www.lodashjs.com/docs/latest#_debouncefunc-wait0-options
export default {
  name: 'd2-debounce',
  functional: true,
  render: function render(createElement, context) {
    // [options.leading=false] (boolean): 指定在延迟开始前调用
    // [options.maxWait] (number): 设置 func 允许被延迟的最大值
    // [options.trailing=true] (boolean): 指定在延迟结束后调用
    var options = function options() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$leading = _ref.leading,
          leading = _ref$leading === void 0 ? false : _ref$leading,
          maxWait = _ref.maxWait,
          _ref$trailing = _ref.trailing,
          trailing = _ref$trailing === void 0 ? true : _ref$trailing;

      return {
        leading: leading,
        maxWait: maxWait,
        trailing: trailing
      }(context.props);
    };

    var wait = context.props.wait;
    var vnodeList = context.slots().default;

    if (vnodeList === undefined) {
      console.warn('<d2-debounce> 组件必须要有子元素');
      return null;
    }

    var vnode = vnodeList[0] || null;

    if (vnode.tag === 'button') {
      var defaultFun = vnode.data.on.click;

      var debounceFun = this._.debounce(defaultFun, wait, options);

      vnode.data.on.click = debounceFun;
    } else if (vnode.componentOptions && vnode.componentOptions.tag === 'el-button') {
      var _defaultFun = vnode.componentOptions.listeners.click;

      var _debounceFun = this._.debounce(_defaultFun, wait, options);

      vnode.componentOptions.listeners.click = _debounceFun;
    } else {
      console.warn('<d2-debounce> 组件内只能出现下面组件的任意一个且唯一 el-button、button');
      return vnode;
    }

    return vnode;
  }
};